<template>
    <card-list-item @click="$emit('click')" :class="{'active': active}">
        <template v-slot:icon><i class="fa-fw fa-tag" :class="{'fas': active, 'far': !active}"></i></template>
        <template v-slot:content>
            <div class="tile-title">{{ discount.title }}</div>
            <div class="meta mt-1"><i class="far fa-fw fa-tag mr-2"></i>{{discount.code}}</div>
            <div class="meta">
                <i class="far fa-fw mr-2 fa-arrow-right"></i>
                <span v-if="discount.applies_to === 'registration'">Conference Registration Fee</span>
                <span v-if="discount.applies_to === 'application'">Conference Application Fee</span>
            </div>
            <div class="meta">
                <i class="far fa-fw mr-2" :class="{'fa-dollar-sign': discount.type === 'amount', 'fa-percent': discount.type === 'percent'}"></i>
                <span v-if="discount.type === 'amount'">{{ discount.value | currency }} off</span>
                <span v-if="discount.type === 'percent'">{{ discount.value }}% Off</span>
            </div>
            <div class="meta" v-if="expired">
                <i class="far fa-fw mr-2 fa-ban has-text-danger"></i>
                Expired
            </div>
        </template>
        <template v-slot:status>
            <div class="stats">
                <span class="stat">
                    <span class="stat" v-if="!discount.is_single_use"><i class="far fa-infinity"></i>{{discount.use_count}}</span>
                    <span class="stat" v-if="discount.is_single_use && discount.is_used"><i class="far fa-check"></i></span>
                </span>
            </div>
        </template>
        <template v-slot:details>
            <div class="tile-details">
                <toolbar class="toolbar">
                    <b-tooltip label="Edit Discount"><button class="icon-only" @click.stop=""><i class="far fa-pencil"></i></button></b-tooltip>
                </toolbar>

                <div class="data mt-1">
                    <data-row mini title="Code">{{discount.code}}</data-row>
                    <data-row mini title="Is Used"><span class="stat" v-if="discount.is_single_use && discount.is_used"><i class="far fa-check"></i></span></data-row>
                    <data-row mini title="Use Count">{{discount.use_count}}</data-row>
                    <data-row mini title="Last Used" v-if="discount.last_used_at">{{discount.last_used_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="Expires" v-if="discount.expires_at">{{discount.expires_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                    <data-row mini title="ID">{{discount.id}}</data-row>
                </div>
            </div>
        </template>
    </card-list-item>
</template>

<script>
    import Toolbar from "@/TIER/components/Toolbar";
    import DataRow from "@/TIER/components/DataRow";
    import CardListItem from "@/TIER/components/CardListItem";
    import moment from "moment";

    export default {
        name: 'ConfDiscountTile',
        components: {CardListItem, DataRow, Toolbar},
        props: {
            card: {
                required: true
            },
            discount: {
                type: Object,
                required: true
            },
            active: {
                type: Boolean,
                default: false
            }
        },
        data: function() {
            return {};
        },
        computed: {
            expired: function() {
                return (this.discount.expires_at && moment(this.discount.expires_at).isBefore(moment()));
            }
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../assets/variables';

    li {
        color: darken($t-primary, 18);
        padding: 0.5rem 0;

        .tile-title {
            font-size: .9rem;
            font-weight: 700;
        }

        .tile-details {
            margin-top: 0.5rem;
        }

        .fa-exclamation-triangle {
            color: orangered;
        }
    }
</style>
